module.exports = "<section class=\"container-fluid\">\r\n\r\n    <div class=\"article-title\">Blank</div>\r\n\r\n</section>"